/**
 * useAuth / useUser — thin wrappers re-exported from the existing AuthContext.
 * Components under @/shared/hooks/useAuth resolve here.
 */
export { useAuth } from '../../context/AuthContext';

import { useAuth } from '../../context/AuthContext';

/** Returns only the current user object (or null while loading). */
export function useUser() {
  return useAuth().user;
}

